import { useMutation, useQueryClient } from "@tanstack/react-query";
import { projectApi } from "./index";

export const usePinProjects = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, status }: { id: string, status: boolean }) => {
      return await projectApi.pinProjects({ id, status });
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["user-context"] });
    },
  });
};

export const useProjects = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ params }: { params?: Record<string, any>; }) => {
      return await projectApi.fetchProjects(params);
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["user-context"] });
    },
  });
};

export const useSearchProjects = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ params }: { params?: Record<string, any>; }) => {
      return await projectApi.searchProjects(params);
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["user-context"] });
    },
  });
};

export const useProjectStages = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ params }: { params?: Record<string, any>; }) => {
      return await projectApi.fetchProjectStages(params);
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["user-context"] });
    },
  });
};

export const useCreateProject = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (params: Record<string, any>) => {
      return await projectApi.createProject(params);
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["user-context"] });
    },
  });
};

export const useEditProject = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ projectId, payload }: { projectId: string, payload: any }) => {
      return await projectApi.editProject({ projectId, payload });
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["user-context"] });
    },
  });
};

export const useGetFormDetails = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (params?: Record<string, any>) => {
      return await projectApi.getFormDetails(params);
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["user-context"] });
    },
  });
};

export const useGetStakeHolders = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      return await projectApi.getStakeHolders();
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: ["user-context"] });
    },
  });
};